/** 
 * @package ŁZPS
 * @copyright (c) Internet Plus
 * @author pawel kryst
 * 
 * @version 1.0.0
 */
/* global jQuery theme */

import './global/respResize.js';
import myTheme from './global/theme.js'; // eslint-disable-line

jQuery(document).ready(function ($) {
    theme.init();
});

